import { DragEndEvent } from "@dnd-kit/core"
import { CategoriesPrivate, SettingsLandingpageCategoryUpdate, SettingsLandingpageService, SettingsLandingpageUpdateRequest, SettingsLandingpageRubricPrivate } from "../client"
import { UseFieldArrayReturn, UseFormReturn } from "react-hook-form"
import { ListCollection } from "@chakra-ui/react"

/* Interfaces */
export interface LandingpageCategoriesProps {
    form: UseFormReturn<SettingsLandingpageUpdateRequest, any, undefined>
    fieldArray: UseFieldArrayReturn<SettingsLandingpageUpdateRequest, "categories.landingpage_categories", "id">
    categoryBlocks: SettingsLandingpageCategoryUpdate[]
    categoryList: CategoriesPrivate | undefined
    categoryCollection: ListCollection<{value: string; label: string;}>
    ct_read: boolean
}

export interface LandingpageRubricsProps {
    form: UseFormReturn<SettingsLandingpageUpdateRequest, any, undefined>
    rubrics: SettingsLandingpageRubricPrivate[] | undefined
    categoryList: CategoriesPrivate | undefined
}


/* Endpoints */
export const readSettingsLandingpage = () => {
  return {
    queryFn: async () => {
      const data = await SettingsLandingpageService.readSettingsLandingpage()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-landingpage"],
  }
}


/* Functions */
export const addBlock = (
    fieldArray: UseFieldArrayReturn<SettingsLandingpageUpdateRequest, "categories.landingpage_categories", "id">,
) => {
    const { fields, insert } = fieldArray

    insert(fields.length, {
        title: "",
        slot_number: fields.length + 1,
        is_active: true,
        publication_display_amount: undefined,
        fk_category_id: "",
    })
}

export const removeBlock = (
    id: string,
    form: UseFormReturn<SettingsLandingpageUpdateRequest, any, undefined>,
    fieldArray: UseFieldArrayReturn<SettingsLandingpageUpdateRequest, "categories.landingpage_categories", "id">,
) => {
    const { fields, remove } = fieldArray
    const { getValues, setValue } = form

    const removeIndex = fields.findIndex(n => n.id === id)
    if (removeIndex === -1) return

    remove(removeIndex)

    const newOrder = getValues("categories.landingpage_categories") ?? []

    newOrder.forEach((item, i) => {
        if ((item.slot_number - 1) !== i) {
            setValue(`categories.landingpage_categories.${i}.slot_number`, (i + 1))
        }
    })
}

export const onDragEnd = (
    event: DragEndEvent,
    form: UseFormReturn<SettingsLandingpageUpdateRequest, any, undefined>,
    fieldArray: UseFieldArrayReturn<SettingsLandingpageUpdateRequest, "categories.landingpage_categories", "id">,
) => {
    const { fields, move } = fieldArray
    const { getValues, setValue } = form

    const { active, over } = event
    if (!over || active.id === over.id) return

    const oldIndex = fields.findIndex(b => b.id === active.id)
    const newIndex = fields.findIndex(b => b.id === over.id)

    move(oldIndex, newIndex)

    const newOrder = getValues("categories.landingpage_categories") ?? []

    newOrder.forEach((item, i) => {
        if ((item.slot_number - 1) !== i) {
            setValue(`categories.landingpage_categories.${i}.slot_number`, (i + 1))
        }
    })
}
